import { Text } from '@ksyos/design-system';

interface ITooV1ProcedureHeading {
    label: string;
}

export function TooV1ProcedureReadHeading({ label }: ITooV1ProcedureHeading) {
    return (
        <Text
            as="h4"
            fontWeight="bold"
            mb={3}
            size="sm"
        >
            {label}
        </Text>
    );
}
